import { useEffect, useRef } from 'react';
import { Carousel as NativeCarousel } from '@fancyapps/ui';
import '@fancyapps/ui/dist/carousel/carousel.css';

const AdvtSlider = (props:any) => {
    const containerRef = useRef(null);
    
    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const options = {
                infinite: true,
                Navigation: {
                    dots: false // Hide dots
                }
            };
            const instance = new NativeCarousel(container, options);
            const autoplayInterval = setInterval(() => {
                instance.slideNext();
            }, 3000); // Change slide every 3 seconds

            return () => {
                if (instance) instance.destroy();
                clearInterval(autoplayInterval);
            };
            // const instance = new NativeCarousel(container, options);
            // return () => {
            //   if(instance) instance.destroy();
            // };
        }
    });

    const openAd = (row: any) => {
        if(row?.target_url){
            window.open(row.target_url, '_blank')
        }
    }
    return (
        <div className="f-carousel" ref={containerRef}>
            {props.data.map((advt: any, key: number) =>
                <div key={`slider_${key}`} className={`previewAdvtImage f-carousel__slide ${advt?.target_url ? 'cursor-pointer' : 'cursor-default'}`} onClick={() => openAd(advt)}>
                    <img className="advt-thumb-image"
                        src={advt.file_link}
                        alt="Picture of the question"
                        width={"100%"}
                        height={"100%"} />
                </div>
            )}
        </div>
    );
}

export default AdvtSlider;
